export const PASSWORD_RESET_PATHS = new Set([
  "/forgot-password",
  "/password-link-sent",
  "/reset-password",
  "/get-start",
]);

export const ACCOUNT_DELETION_PATHS = new Set(["/delete-account"]);

export const PUBLIC_MERCHANT_PATHS = new Set(["/merchant/register"]);

export const ADMIN_ROLES = ["super_admin", "admin", "developer"];
export const MERCHANT_ROLES = ["merchant"];
export const AUTH_ROLES = [...ADMIN_ROLES, ...MERCHANT_ROLES];

export const isPasswordResetPath = (pathname: string) => PASSWORD_RESET_PATHS.has(pathname);

export const isAccountDeletionPath = (pathname: string) => ACCOUNT_DELETION_PATHS.has(pathname);

export const isPublicMerchantPath = (pathname: string) =>
  PUBLIC_MERCHANT_PATHS.has(pathname) || pathname.startsWith("/merchant/register/");

export const isEventDeepLinkPath = (pathname: string) =>
  /^\/event\/[^/]+$/.test(pathname) &&
  pathname !== "/event/create" &&
  pathname !== "/event/editor" &&
  !pathname.startsWith("/event/public");

export const isNewsDeepLinkPath = (pathname: string) =>
  /^\/news\/[^/]+$/.test(pathname) &&
  !pathname.startsWith("/news/view/") &&
  pathname !== "/news/create" &&
  pathname !== "/news/update";

export const isQRScannerPath = (pathname: string) => pathname.startsWith("/qr-scanner");

export const isAnonymousPublicPath = (pathname: string, search: string) => {
  const isEventPublicPage =
    pathname === "/qr/registration-event" && new URLSearchParams(search).has("token");

  return (
    isEventPublicPage ||
    pathname === "/download" ||
    pathname === "/billing/success" ||
    isEventDeepLinkPath(pathname) ||
    isNewsDeepLinkPath(pathname) ||
    isPublicMerchantPath(pathname)
  );
};
